import React, { useState, useEffect } from "react";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import { useNavigate } from "react-router-dom";
import CalenderAvailability from "./CalenderAvailability";
import CalenderPreferences from "./CalenderPreferences";

export default function CalenderSetting() {
  const path = "Assets/scss/FindWork.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("Availability");

  

  useEffect(() => {
    switch (activeTab) {
      case "Availability":
        setActiveTab("Availability");
        break;
      case "Preferences":
        setActiveTab("Preferences");
        break;
      default:
        setActiveTab("Availability");
        break;
    }
  }, [activeTab, navigate]);

  return (
    <div className="project-section">
      <div className="col-md-12 dashboard tab-sec">
        <div className="tab-content row">
          <div className="dashboard-left calendar-left">
            <div className="dashboard-sidebar">
              <h6>Calendar Settings</h6>
              <div className="sidebar-menu">
                <a  className={`nav-link ${activeTab == "Availability" ? "active" : ""}`}
                  onClick={() => setActiveTab("Availability")}
                >
                  Availability</a>
                {/* <a  className={`nav-link ${activeTab == "Preferences" ? "active" : ""}`}
                  onClick={() => setActiveTab("Preferences")}
                >
                  Preferences</a> */}
              </div>
            </div>
            {/* <p>Calendar Settings</p>
            <span
              className={`nav-link ${activeTab == "Availability" ? "active" : ""}`}
              onClick={() => setActiveTab("Availability")}
            >
              Availability
            </span>
            <span
              className={`nav-link ${activeTab == "Preferences" ? "active" : ""}`}
              onClick={() => setActiveTab("Preferences")}
            >
              Preferences
            </span> */}
          </div>
          <div className="dashboard-right">
            <div className="tab-content order-section">
              <h3 className="font-42">Calendar Settings</h3>
              <div
                className={`tab-pane ${activeTab == "Availability" ? "active" : ""}`}
              >
                {activeTab == "Availability" && <CalenderAvailability />}
              </div>
              <div
                className={`tab-pane ${activeTab == "Preferences" ? "active" : ""}`}
              >
                {activeTab == "Preferences" && <CalenderPreferences />}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
